import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Toggle } from '@canaveral/components';
import ImageCarousel from '../../../../website/components/stateful/ImageCarousel';
import styles from './styles.scss';

const propTypes = {
  autoplay: PropTypes.bool.isRequired,
  bannerText: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    mediumId: PropTypes.string,
    file: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    target: PropTypes.string,
  })).isRequired,
  imageClassname: PropTypes.string,
  setAutoplay: PropTypes.func.isRequired,
  setBannerText: PropTypes.func.isRequired,
  setShowBanner: PropTypes.func.isRequired,
  showBanner: PropTypes.bool.isRequired,
};
const defaultProps = {
  bannerText: undefined,
  imageClassname: undefined,
};

const Options = ({
  autoplay,
  bannerText,
  images,
  imageClassname,
  setAutoplay,
  setBannerText,
  setShowBanner,
  showBanner,
}) => (
  <>
    <div className={styles.optionHeader}>
      Slideshow Options
    </div>
    <div className={styles.bannerContainer}>
      <Toggle onClick={() => setShowBanner(!showBanner)} checked={showBanner} />
      Include callout banner
      {showBanner && (
        <>
          <div className={styles.bannerText}>
            Banner Text
          </div>
          <InputGroup>
            <InputGroup.Text onChange={e => setBannerText(e.target.value)} value={bannerText} />
          </InputGroup>
        </>
      )}
    </div>
    <div className={styles.slideshow}>
      <ImageCarousel
        images={images}
        imageClassname={imageClassname}
        bannerText={bannerText}
        autoplay={autoplay}
        showBanner={showBanner}
      />
    </div>

    <div className={styles.optionHeader}>
      Slideshow Settings
    </div>
    <Toggle onClick={() => setAutoplay(!autoplay)} checked={autoplay} />
    Autoplay Slideshow
  </>
);

Options.propTypes = propTypes;
Options.defaultProps = defaultProps;

export default Options;
